import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  makeStyles
} from '@material-ui/core';

import { actions } from 'src/redux';

const useStyles = makeStyles(() => ({
  root: {}
}));

const ProfileDetails = ({ className, menu, marcas }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [brand, setBrand] = useState(menu.brand);
  const [titlePT, setTitlePT] = useState(menu.titlePT);
  const [titleEN, setTitleEN] = useState(menu.titleEN);
  const [typeLink, setTypeLink] = useState(menu.typeLink);
  const [url, setUrl] = useState(menu.url);
  const [target, setTarget] = useState(menu.target);
  const [exclusiveName, setExclusiveName] = useState(menu.exclusiveName);

  const handleBrand = (event) => setBrand(event.target.value);
  const handleTitlePT = (event) => setTitlePT(event.target.value);
  const handleTitleEN = (event) => setTitleEN(event.target.value);
  const handleTypeLink = (event) => setTypeLink(event.target.value);
  const handleUrl = (event) => setUrl(event.target.value);
  const handleTarget = (event) => setTarget(event.target.value);
  const handleExclusiveName = (event) => setExclusiveName(event.target.value);

  const handleSubmit = () => {
    const updateMenu = {
      brand,
      titlePT,
      titleEN,
      typeLink,
      url,
      target,
      exclusiveName
    };
    dispatch(actions.menu.editMenu.update(menu._id, updateMenu));
  };

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader title="Editar itens de menu" />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Nome exclusivo"
                name="exclusiveName"
                type="text"
                onChange={handleExclusiveName}
                required
                value={exclusiveName}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Titulo"
                name="titlePT"
                type="text"
                onChange={handleTitlePT}
                required
                value={titlePT}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Titulo (Inglês)"
                name="titleEN"
                type="text"
                onChange={handleTitleEN}
                required
                value={titleEN}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl variant="outlined" className={classes.formControl} fullWidth>
                <InputLabel htmlFor="brand">Marca:</InputLabel>
                <Select
                  native
                  value={brand}
                  onChange={handleBrand}
                  label="Marca:"
                  inputProps={{
                    name: 'brand',
                    id: 'brand',
                  }}
                >
                  <option aria-label="None" value="" />
                  {marcas.map((marca) => {
                    return <option value={marca}>{marca}</option>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl variant="outlined" className={classes.formControl} fullWidth>
                <InputLabel htmlFor="typeLink">Tipo de Link:</InputLabel>
                <Select
                  native
                  value={typeLink}
                  onChange={handleTypeLink}
                  label="Tipo de Link:"
                  inputProps={{
                    name: 'typeLink',
                    id: 'typeLink',
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value="internal">Interno</option>
                  <option value="external">Externo</option>
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="URL"
                name="url"
                type="text"
                onChange={handleUrl}
                required
                value={url}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <FormControl variant="outlined" className={classes.formControl} fullWidth>
                <InputLabel htmlFor="typeTarget">Abrir em:</InputLabel>
                <Select
                  native
                  value={target}
                  onChange={handleTarget}
                  label="Abrir em:"
                  inputProps={{
                    name: 'typeTarget',
                    id: 'typeTarget',
                  }}
                >
                  <option aria-label="None" value="" />
                  <option value="sametab">Mesma Aba</option>
                  <option value="newtab">Nova Aba</option>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button color="primary" variant="contained" onClick={handleSubmit}>
            Atualizar
          </Button>
        </Box>
      </Card>
    </form>
  );
};

ProfileDetails.propTypes = {
  className: PropTypes.string,
  menu: PropTypes.object,
  marcas: PropTypes.array
};

export default ProfileDetails;
